webpackJsonp([205920658058625],{

/***/ 379:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Sunny Crest","author":"Brian Capouch"}},"mongodbOsconBlogposts":{"id":"5b3c10b01a7d792030b15b03","path":"/outhouse/","post":{"childMarkdownRemark":{"html":"<p>For those who have never seen a brick shithouse, this is one to envy.  It is a three-seater, and sits atop a cleanable concrete tank.  It has windows at the top on either side, and the window on the north side is made of beveled glass.</p>\n<p>This structure, and the oil house, both were built at the same time as the main house, and both still retain their original slate roofs, which also once adorned the brick house.  There is also a sidewalk leading from the outhouse to the west entrance of the main house.</p>\n<p><img src=\"./IMAGES/outhouse.jpg\" alt=\"Outhouse\"></p>\n<center>\nView of outhouse taken from the cob house\n</center>","frontmatter":{"title":"Brick Outhouse"}}}}},"pathContext":{"id":"5b3c10b01a7d792030b15b03"}}

/***/ })

});


// WEBPACK FOOTER //
// path---outhouse-aff0df5a286eb5152e18.js